<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
/* eslint-disable */
import bods from "bods";
// window.localStorage.clear()
bods.app.init();

export default {
    name: "App"
};
</script>

<style lang="scss" scoped>
#app {
    height: 100%;
    margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue